<script setup lang="ts">
import DangerDialog from '@/components/dialog/DangerDialog.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import StudentProfileParentForm from '@/domains/student-app/components/profile/StudentProfileParentForm.vue';

import Check from '@/icons/line/check.svg';

const { show, close } = useDialog();
const [isCancelDialogOpen, toggleCancelDialog] = useToggle(false);

const isDialogOpen = computed(() => !isCancelDialogOpen.value && show.value);

const form = useForm({
  url: route('student.profile.parent.store'),
  method: 'POST',
  fields: {
    first_name: '',
    last_name: '',
    email: '',
    cell_phone: ''
  }
});

function handleFormSubmit() {
  form.submit();
}

function handleToggleCancelDialog() {
  if (form.isDirty) {
    toggleCancelDialog();
    return;
  }
  close();
}

function handleCancelDialogConfirm() {
  toggleCancelDialog();
  close();
}
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <Dialog
    title="Create Parent"
    :confirmButtonIcon="Check"
    :isLoading="form.processing"
    :isOpen="isDialogOpen"
    cancelButtonLabel="Cancel"
    confirmButtonLabel="Confirm"
    @onCancel="form.reset"
    @onClose="handleToggleCancelDialog"
    @onConfirm="handleFormSubmit"
  >
    <template #form>
      <StudentProfileParentForm :form="form" />
    </template>
  </Dialog>
  <DangerDialog
    title="Discard Changes?"
    message="Your changes will not be saved."
    :isOpen="isCancelDialogOpen"
    cancelButtonLabel="Stay on this page"
    confirmButtonLabel="Discard changes"
    isStacked
    @onCancel="toggleCancelDialog"
    @onClose="toggleCancelDialog"
    @onConfirm="handleCancelDialogConfirm"
  />
</template>
